import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoginAPIURL } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import "./login.css";
import logo from "../assets/images/logoinlogin.PNG"
import user from "../assets/images/Untitled_design-removebg-preview33.png"
import users from "../assets/images/group.png"
import BeforeLoginHeader from '../commonlayouts/beforeloginheader';
import FooterLayout from '../commonlayouts/beforeloginfooter';
import Swal from 'sweetalert2';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
function Login() {
  const formSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string()
      .required('Password is mandatory')
  })

  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, setValue, formState } = useForm(formOptions);
  const { errors } = formState;
  const { isSubmitting } = formState;
  const apiUrl = LoginAPIURL.APIURL;
  const [roleid, setRoleID] = React.useState(3);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const clientID = localStorage.getItem("clientID")
  const clientData = JSON.parse(localStorage.getItem("clientData"));
  const clientName = clientData?.companyName
  const [roleError, setRoleError] = useState('');
   const [showPassword, setShowPassword] = useState(false);
   useEffect(() => {
  const interval = setInterval(() => {
    const clientID = localStorage.getItem("clientID");
    const clientData = localStorage.getItem("clientData");

    if (
      !clientID || clientID === "undefined" || clientID === "null" ||
      !clientData || clientData === "undefined" || clientData === "null"
    ) {
      clearInterval(interval);
      navigate("/");
    }
  }, 1000); // checks every 1 second

  return () => clearInterval(interval);
}, [navigate]);
  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();
  //  if (roleid == 5) {
  //     navigate("/Admin/ListofallClients")
  //     return;
  //    }
if (!roleid || isNaN(roleid)) {
  setRoleError('Please select a valid role.');
  setIsLoading(false);
  return;
} else {
  setRoleError('');
}
    setIsLoading(true);

    const fliterdata = {
       email: data.email,
       password: data.password, 
       guid: roleid != 5 ? clientID : '3fa85f64-5717-4562-b3fc-2c963f66afa6',
       roleID: roleid
      };
       Axios.post(apiUrl, fliterdata)
      .then((result) => {
        setIsLoading(false);
        localStorage.setItem('jwtToken', result.data.jwtToken)
        localStorage.setItem('tokenid', result.data.userID)
        localStorage.setItem('userID', result.data.userID)
        localStorage.setItem('guid', result.data.guid)
        localStorage.setItem('firstName', result.data.firstName)
        localStorage.setItem('email', result.data.email)
        localStorage.setItem('mobileNumber', result.data.mobileNumber)
        localStorage.setItem('lastName', result.data.lastName)
        localStorage.setItem('companyName', result.data.companyName)
        localStorage.setItem('companyURL', result.data.companyURL)
        localStorage.setItem('roleID', result.data.roleID)
        localStorage.setItem('employerGuid', result.data.employerGuid)
        localStorage.setItem('subscriptionEndDate', result.data.subscriptionEndDate)
        localStorage.setItem('guid', result.data.guid)
        localStorage.setItem('isSubscriptionActive', result.data.isSubscriptionActive)
        localStorage.setItem('subscriptionStartDate', result.data.subscriptionStartDate)
        localStorage.setItem('planName', result.data.planName)
        localStorage.setItem('usertype', result.data.usertype)
        sessionStorage.setItem('email', result.data.email)

        if (result.data.message === 'Success'&&result.data.roleID==2) {
          navigate("/Employer/Dashboard")
          // toast.success('Successfully Logged in', { autoClose: 5000 })
          // if (result.data.roleID === 2) {
            
          // } 
          // else if (result.data.roleID === 2) {

          //   if (selecteditemsarray !== null && selecteditemsarray !== "") {
          //     //alert(jobid);
          //     navigate("/Employer/SelectCandidatesWithLogin?array=" + selecteditemsarray);
          //   }
          //   else if(candidatesID!== null && candidatesID!==""){
          //     navigate("/Employer/ViewCandidateDetails?candidatesID="+candidatesID )
          //   }
          //  else navigate("/Employer/");
          // } 
          // else {
          //   // toast.error('Select Correct Role option.', { autoClose: 5000 })
          //   setIsLoading(false)
          // }
        }
       else  if (result.data.message === 'Success'&&result.data.roleID==3) {
          navigate("/Employer/UserDashboard")
       }
       else  if (result.data.message === 'Success'&&result.data.roleID==4) {
        navigate("/Employer/CEMDashboard")
     }
     else if (result.data.message === 'Success' &&result.data.roleID==5) {
       navigate("/Admin/ListofallClients")
     }

      else  if (result.data.message === 'Not Authorized') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Select Correct Role option',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Select Correct Role option.', { autoClose: 5000 })
        }
        else if(result.data.message==="Email or password is incorrect") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Invalid User Name or Password, Please check your Email.',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Invalid User Name or Password, Please check your Email.', { autoClose: 5000 })
        }
        else if(result.data.message==="User Deactivated") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'User is Deactivated',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Invalid User Name or Password, Please check your Email.', { autoClose: 5000 })
        }

      }).catch(function (error) {
        console.log("Error" + error)
        setIsLoading(false)
      })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }

  const renderCheckbox = (value, label, imageSrc) => {
    const isSelected = roleid === value;
    const checkboxStyle = isSelected ? { border: '2px solid #00a7ac' } : {};

    return (
      <div
        className="card p-3 text-center"
        style={{ border: 'none', boxShadow: 'none', ...checkboxStyle }}
        onClick={() => setRoleID(isSelected ? '' : value)}
      >
        <img style={{ margin:"auto",width: 80, height: 80, borderRadius:"50%", boxShadow: "0 0 0 1px grey" }} src={imageSrc} alt={label}  />
        <h5 className="mt-3" style={{ color: '#00a7ac' }}>{label}</h5>
      </div>
    );
  };

  // const getClassName = (clientId) => {
  //   if (clientId == '') {
  //     return "col-sm-12 col-xl-3 col-lg-3 col-md-3"; 
  //   }
  //   return "col-sm-12 col-xl-4 col-lg-4 col-md-4";
  // };
  return (
    <>
      <BeforeLoginHeader>
        {isLoading ? (
          <center>
            <LoadingSpinner />
          </center>
        ) : (
          <div className="container mt-5">
             {/* <Link to="/NonHiredCandidates"><h5>Non Hired Candidates List</h5></Link> */}
                                    {/* <Link to="/AddInterviewQuestions"><h5>Add Questions</h5></Link> */}
            <form onSubmit={handleSubmit(onSubmit)} id="loginform">
              <div className="row" >
                <div className="shadow col-md-6 col-xl-6 col-lg-6 col-sm-12 login-logo" style={{ backgroundColor: "#00a7ac", height: 600 }}>
                  <div className="text-center" style={{ marginTop: 190 }}>
                    {/* <img src={logo}  height={60} alt="Logo" /> */}
                    <h1 style={{color:"#fff"}}>{clientName}</h1>
                  </div>
                </div>

                <div className="col-md-6 col-xl-6 col-lg-6 col-sm-12 shadow-sm p-3 " style={{ height: 600 }}>
                  <h2 className="text-center mb-3" style={{ color: "#00a7ac" }}>Login</h2>
                  <div className="row mt-1">
           
            <div className="col-sm-12 col-xl-6 col-lg-6 col-md-6">
              {renderCheckbox(3, 'User', users)}
            </div>
             <div className="col-sm-12 col-xl-6 col-lg-6 col-md-6">
            
              {renderCheckbox(2, 'Admin', user)}
            </div>
       {roleError && (
    <div className="invalid-feedback d-block ml-3">
      {roleError}
    </div>
  )}
          </div>

            {/* <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              {renderCheckbox(4, 'Cem', defaultimg)}
            </div> */}
           {/* {clientID == 'c21d2f73-0e48-45d7-a19c-9223bf78a23c' &&
            <div className={getClassName(clientID)}>
            
            {renderCheckbox(5, 'Super Admin', defaultimg)}
          </div>
          } */}
         

                  <div className="mb-3 mt-3">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                      <input
                        placeholder='Email'
                        type="email"
                        name="email"
                        {...register("email")}
                        className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}
                      />
                    </OverlayTrigger>
                    <div className="invalid-feedback"> {errors.email?.message}</div>
                  </div>
<div className="mb-3 mt-4 position-relative">
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Password</Tooltip>
    )}
  >
    <input
      placeholder="Password"
      type={showPassword ? 'text' : 'password'}
      name="password"
      {...register("password")}
      style={{ fontWeight: "bold", fontSize: 22 }}
      className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`}
    />
  </OverlayTrigger>

  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: 'absolute',
      top: '50%',
      right: '15px',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      zIndex: 2,
      color: '#6c757d'
    }}
  >
    {showPassword ? <FaEye  size={20}/> : <FaEyeSlash  size={20}/>}
  </span>

  <div className="invalid-feedback">{errors.password?.message}</div>
</div>


                  <div>
                    <ul style={{ listStyle: "none" }} className='d-flex justify-content-between'>
                      {/* <li>
                        <Link to={`/Register?clientId=${clientID}`}style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>Register</Link>
                      </li> */}
                      <li>
                        <Link to="/account/ForgotPassword" style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>Forgot Password</Link>
                      </li>
                      {/* <li>
                        <Link to="/account/ResetPassword" style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>Reset Password</Link>
                      </li> */}
                    </ul>
                  </div>
                    <div className='text-center'>
                    <button
                      disabled={isSubmitting}
                      className="btn btn-primary mt-3"
                      style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15 }}
                    >
                      {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
      </BeforeLoginHeader>
      <FooterLayout />
    </>
  )
}

export default Login;
